import { ReactElement } from "react";

const svgKeys = (className: string): { [key: string]: ReactElement } => {
  return {
    search_icon: (
      <svg className={className} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.5 11H11.71L11.43 10.73C12.4439 9.55402 13.0011 8.0527 13 6.5C13 5.21442 12.6188 3.95772 11.9046 2.8888C11.1903 1.81988 10.1752 0.986756 8.98744 0.494786C7.79973 0.00281635 6.49279 -0.125905 5.23192 0.124899C3.97104 0.375703 2.81285 0.994767 1.90381 1.90381C0.994767 2.81285 0.375703 3.97104 0.124899 5.23192C-0.125905 6.49279 0.00281635 7.79973 0.494786 8.98744C0.986756 10.1752 1.81988 11.1903 2.8888 11.9046C3.95772 12.6188 5.21442 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
          fill="#A4A4A4"
        />
      </svg>
    ),
    paginationRight: (
      <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22998 18.23L1.99998 20L12 10L1.99998 0L0.22998 1.77L8.45998 10L0.22998 18.23Z" fill="#14AA40" />
      </svg>
    ),
    paginationLeft: (
      <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.67 1.87001L9.9 0.100006L0 10L9.9 19.9L11.67 18.13L3.54 10L11.67 1.87001Z" fill="#14AA40" />
      </svg>
    ),
    sortArrow: (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12L0 6L1.05 4.93125L5.25 9.13125V0H6.75V9.13125L10.95 4.93125L12 6L6 12Z" fill="#727E74" />
      </svg>
    ),
    editIcon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M2 17.9999H3.4L12.025 9.3749L10.625 7.9749L2 16.5999V17.9999ZM16.3 7.9249L12.05 3.7249L14.875 0.899902L19.1 5.1249L16.3 7.9249ZM0 19.9999V15.7499L10.6 5.1499L14.85 9.3999L4.25 19.9999H0ZM11.325 8.6749L10.625 7.9749L12.025 9.3749L11.325 8.6749Z"
              fill="#364238"
          />
      </svg>
    ),
    deleteIcon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.4 16.5L12 13.9L14.6 16.5L16 15.1L13.4 12.5L16 9.9L14.6 8.5L12 11.1L9.4 8.5L8 9.9L10.6 12.5L8 15.1L9.4 16.5ZM7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.196 20.021 5 19.55 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.021 20.8043 17.55 21 17 21H7ZM17 6H7V19H17V6Z" fill="#E70000"/>
      </svg>
    ),
  }
};

export default svgKeys